module.exports = __webpack_public_path__ + "assets/img/app-dec1.083e9ce6.svg";